import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'
import type { Meta } from '../api/types'

export function useMeta() {
	return useQuery({ queryKey: ['meta'], queryFn: () => api.get<Meta>('/api/v1/meta'), staleTime: 30 * 60_000 })
}

export const ROOT_GENRE: Record<string, number> = { iphone: 36, ipad: 36, appletv: 36, watch: 36, mac: 39 }

export const PLATFORM_LABELS: Record<string, string> = {
	iphone: 'iPhone',
	ipad: 'iPad',
	mac: 'Mac',
	appletv: 'Apple TV',
	watch: 'Watch',
	vision: 'Vision',
}

export const CHART_TYPE_LABELS: Record<string, string> = { free: 'Free', paid: 'Paid', grossing: 'Grossing' }

/** Genres charted for a platform, ordered root → top-level → subgenres, with display labels. */
export function genreOptions(meta: Meta | undefined, platform: string) {
	if (!meta) return []
	const genres = meta.genres.filter((g) => g.platforms.includes(platform))
	const root = genres.find((g) => g.parentId === null)
	const top = genres.filter((g) => root && g.parentId === root.id).sort((a, b) => a.name.localeCompare(b.name))
	const out: { id: number; label: string }[] = root ? [{ id: root.id, label: 'All categories' }] : []
	for (const g of top) {
		out.push({ id: g.id, label: g.name })
		for (const sub of genres.filter((s) => s.parentId === g.id).sort((a, b) => a.name.localeCompare(b.name))) {
			out.push({ id: sub.id, label: `${g.name} › ${sub.name}` })
		}
	}
	return out
}
